import { get, post } from '@/utils/request';

export const login = (params) => {
  params.plat_form = 2;
  return post('/api/v1/login', params);
};

export const loginCheck = (params) => {
  return post('/api/v1/login_check', params);
};

export const sendSmscode = (params) => {
  return post('/api/v1/send_smscode', params);
};

export const getUserInfoById = (params) => {
  return get('/api/v1/admin_info', params);
};

export const getNav = () => {
  return get('/api/v1/nav_by_admin');
};

export const userinfo = () => {
  return get('/api/v1/userinfo');
};

export const user_info = (params) => {
  return post('/api/v1/user_info', params);
};

export const modify_pw = (params) => {
  return post('/api/v1/modify_pw', params);
};
